import Vue from 'vue'
import Router from 'vue-router'
import Wowy from '@/components/Wowy.vue'
import Totals from '@/components/Totals.vue'
import GameLogs from '@/components/GameLogs.vue'
import PlayerOnOff from '@/components/PlayerOnOff.vue'
import PossessionFinder from '@/components/PossessionFinder.vue'
import GameStats from '@/components/GameStats.vue'
import Games from '@/components/Games.vue'
import AssistNetworks from '@/components/AssistNetworks.vue'
import ScatterPlots from '@/components/ScatterPlots.vue'
import YearOverYear from '@/components/YearOverYear.vue'
import ScoreMargin from '@/components/ScoreMargin.vue'
import FourFactorsOnOffCharts from '@/components/FourFactorsOnOffCharts.vue'
import EntityStatsBySeason from '@/components/EntityStatsBySeason.vue'
import Index from '@/components/Index.vue'
import WowyCombos from '@/components/WowyCombos.vue'
import PlayerPlayingTime from '@/components/PlayerPlayingTime.vue'
import TeamChartByNumberOfStarters from '@/components/TeamChartByNumberOfStarters.vue'
import Live from '@/components/Live.vue'
import TeamPossessionLength from '@/components/TeamPossessionLength.vue'
import WowyComboPlayingTime from '@/components/WowyComboPlayingTime.vue'
import Donate from '@/components/Donate.vue'
import PaceEfficiencySummary from '@/components/PaceEfficiencySummary.vue'
import PaceEfficiencyBySeason from '@/components/PaceEfficiencyBySeason.vue'
import ScoreTimeSummary from '@/components/ScoreTimeSummary.vue'
import OpponentLineupSummary from '@/components/OpponentLineupSummary.vue'
import ShotQuerySummary from '@/components/ShotQuerySummary.vue'
import AssistCombos from '@/components/AssistCombos.vue'
import TopResults from '@/components/TopResults.vue'
import Shots from '@/components/Shots.vue'
import LineupSubunits from '@/components/LineupSubunits.vue'
import RelativeOffDefRtg from '@/components/RelativeOffDefRtg.vue'
import Endgame from '@/components/Endgame.vue'
import TeamLeverageSummary from '@/components/TeamLeverageSummary.vue'

const PageNotFound = {
  template: `<h1>Page Not Found</h1>`
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/wowy/:league',
      name: 'wowy',
      component: Wowy
    },
    {
      path: '/possession-finder/:league',
      name: 'possession_finder',
      component: PossessionFinder
    },
    {
      path: '/totals/:league/:type', // types player, team, opponent, lineup, lineup-opponent, lineup-player
      name: 'totals',
      component: Totals
    },
    {
      path: '/game-logs/:league/:type', // types player, team, opponent, lineup, lineup-opponent
      name: 'game_logs',
      component: GameLogs
    },
    {
      path: '/on-off/:league/:type', // types player, team, stat
      name: 'on_off',
      component: PlayerOnOff
    },
    {
      path: '/game-stats/:type/:game_id', // types player, lineup, lineup-opponent
      name: 'game_stats',
      component: GameStats
    },
    {
      path: '/games/:league',
      name: 'games',
      component: Games
    },
    {
      path: '/assist-networks/:league/:type', // types game, team, lineup
      name: 'assist_networks',
      component: AssistNetworks
    },
    {
      path: '/scatter-plots/:league',
      name: 'scatter_plots',
      component: ScatterPlots
    },
    {
      path: '/year-over-year-plots/:league',
      name: 'year_over_year_plot',
      component: YearOverYear
    },
    {
      path: '/season-stats/:league',
      name: 'season_stats',
      component: EntityStatsBySeason
    },
    {
      path: '/score-margin/:league',
      name: 'score_margin',
      component: ScoreMargin
    },
    {
      path: '/four-factors-on-off/:league',
      name: 'four_factors_on_off',
      component: FourFactorsOnOffCharts
    },
    {
      path: '/wowy-combos/:league',
      name: 'wowy_combos',
      component: WowyCombos
    },
    {
      path: '/player-playing-time-distribution/:league',
      name: 'player_playing_time_distribution',
      component: PlayerPlayingTime
    },
    {
      path: '/number-of-starter-stats-by-team/:league',
      name: 'number_of_starter_stats_by_team',
      component: TeamChartByNumberOfStarters
    },
    {
      path: '/live/:league/:game_id?/:type?',
      name: 'live',
      component: Live
    },
    {
      path: '/possession-length-by-team/:league',
      name: 'team_possession_length',
      component: TeamPossessionLength
    },
    {
      path: '/wowy-combo-playing-time-distribution/:league',
      name: 'wowy_combo_playing_time_distribution',
      component: WowyComboPlayingTime
    },
    {
      path: '/404',
      name: 'not_found',
      component: PageNotFound
    },
    {
      path: '/donate',
      name: 'donate',
      component: Donate
    },
    {
      path: '/pace-efficiency-summary/:league',
      name: 'pace_efficiency_summary',
      component: PaceEfficiencySummary
    },
    {
      path: '/pace-efficiency-by-season/:league',
      name: 'pace_efficiency_by_season',
      component: PaceEfficiencyBySeason
    },
    {
      path: '/score-time-summary/:league',
      name: 'score_time_summary',
      component: ScoreTimeSummary
    },
    {
      path: '/opponent-lineup-summary/:league',
      name: 'opponent_lineup_summary',
      component: OpponentLineupSummary
    },
    {
      path: '/shot-query-summary/:league',
      name: 'shot_query_summary',
      component: ShotQuerySummary
    },
    {
      path: '/assist-combo-summary/:league',
      name: 'assist_combo_summary',
      component: AssistCombos
    },
    {
      path: '/top-results/:league/:type', // type is game or season
      name: 'top_results',
      component: TopResults
    },
    {
      path: '/shots/:league',
      name: 'shots',
      component: Shots
    },
    {
      path: '/lineup-subunits/:league',
      name: 'lineup_subunits',
      component: LineupSubunits
    },
    {
      path: '/relative-off-def-efficiency/:league',
      name: 'relative_off_def_rtg',
      component: RelativeOffDefRtg
    },
    {
      path: '/endgame/:league',
      name: 'endgame',
      component: Endgame
    },
    {
      path: '/team-leverage-summary/:league',
      name: 'team_leverage_summary',
      component: TeamLeverageSummary
    },
    {
      path: '/nba/player-stats',
      redirect: to => {
        return {name: 'totals', params: {league: 'nba', type: 'player'}}
      }
    },
    {
      path: '/gleague/player-stats',
      redirect: to => {
        return {name: 'totals', params: {league: 'gleague', type: 'player'}}
      }
    },
    {
      path: '/nba/team-stats',
      redirect: to => {
        const { query } = to
        if (query.Type === 'Opponent') {
          return {name: 'totals', params: {league: 'nba', type: 'opponent'}}
        } else {
          return {name: 'totals', params: {league: 'nba', type: 'team'}}
        }
      }
    },
    {
      path: '/gleague/team-stats',
      redirect: to => {
        const { query } = to
        if (query.Type === 'Opponent') {
          return {name: 'totals', params: {league: 'gleague', type: 'opponent'}}
        } else {
          return {name: 'totals', params: {league: 'gleague', type: 'team'}}
        }
      }
    },
    {
      path: '/nba/lineup-stats',
      redirect: to => {
        const { query } = to
        if (query.Type === 'Opponent') {
          return {name: 'totals', params: {league: 'nba', type: 'lineup-opponent'}}
        } else {
          return {name: 'totals', params: {league: 'nba', type: 'lineup'}}
        }
      }
    },
    {
      path: '/gleague/lineup-stats',
      redirect: to => {
        const { query } = to
        if (query.Type === 'Opponent') {
          return {name: 'totals', params: {league: 'gleague', type: 'lineup-opponent'}}
        } else {
          return {name: 'totals', params: {league: 'gleague', type: 'lineup'}}
        }
      }
    },
    {
      path: '/nba/lineup-player-stats',
      redirect: to => {
        return {name: 'totals', params: {league: 'nba', type: 'lineup-player'}}
      }
    },
    {
      path: '/gleague/lineup-player-stats',
      redirect: to => {
        return {name: 'totals', params: {league: 'gleague', type: 'lineup-player'}}
      }
    },
    {
      path: '/nba/player-game-logs',
      redirect: to => {
        const { query } = to
        var newQueryParams = {}
        newQueryParams.EntityId = query.PlayerId
        newQueryParams.Season = query.Season
        newQueryParams.SeasonType = query.SeasonType
        return {name: 'game_logs', params: {league: 'nba', type: 'player'}, query: newQueryParams}
      }
    },
    {
      path: '/gleague/player-game-logs',
      redirect: to => {
        const { query } = to
        var newQueryParams = {}
        newQueryParams.EntityId = query.PlayerId
        newQueryParams.Season = query.Season
        newQueryParams.SeasonType = query.SeasonType
        return {name: 'game_logs', params: {league: 'gleague', type: 'player'}, query: newQueryParams}
      }
    },
    {
      path: '/nba/team-game-logs',
      redirect: to => {
        const { query } = to
        var newQueryParams = {}
        newQueryParams.EntityId = query.TeamId
        newQueryParams.Season = query.Season
        newQueryParams.SeasonType = query.SeasonType
        if (query.Type === 'Opponent') {
          return {name: 'game_logs', params: {league: 'nba', type: 'opponent'}, query: newQueryParams}
        } else {
          return {name: 'game_logs', params: {league: 'nba', type: 'team'}, query: newQueryParams}
        }
      }
    },
    {
      path: '/gleague/team-game-logs',
      redirect: to => {
        const { query } = to
        var newQueryParams = {}
        newQueryParams.EntityId = query.TeamId
        newQueryParams.Season = query.Season
        newQueryParams.SeasonType = query.SeasonType
        if (query.Type === 'Opponent') {
          return {name: 'game_logs', params: {league: 'gleague', type: 'opponent'}, query: newQueryParams}
        } else {
          return {name: 'game_logs', params: {league: 'gleague', type: 'team'}, query: newQueryParams}
        }
      }
    },
    {
      path: '/nba/lineup-game-logs',
      redirect: to => {
        const { query } = to
        var newQueryParams = {}
        newQueryParams.EntityId = query.LineupId
        newQueryParams.Season = query.Season
        newQueryParams.SeasonType = query.SeasonType
        if (query.Type === 'Opponent') {
          return {name: 'game_logs', params: {league: 'nba', type: 'lineup-opponent'}, query: newQueryParams}
        } else {
          return {name: 'game_logs', params: {league: 'nba', type: 'lineup'}, query: newQueryParams}
        }
      }
    },
    {
      path: '/gleague/lineup-game-logs',
      redirect: to => {
        const { query } = to
        var newQueryParams = {}
        newQueryParams.EntityId = query.LineupId
        newQueryParams.Season = query.Season
        newQueryParams.SeasonType = query.SeasonType
        if (query.Type === 'Opponent') {
          return {name: 'game_logs', params: {league: 'gleague', type: 'lineup-opponent'}, query: newQueryParams}
        } else {
          return {name: 'game_logs', params: {league: 'gleague', type: 'lineup'}, query: newQueryParams}
        }
      }
    },
    {
      path: '/game-stats',
      redirect: to => {
        const { query } = to
        return {name: 'game_stats', params: {game_id: query.GameId, type: 'player'}, query: {}}
      }
    },
    {
      path: '/lineup-game-stats',
      redirect: to => {
        const { query } = to
        if (query.Type === 'Opponent') {
          return {name: 'game_stats', params: {game_id: query.GameId, type: 'lineup-opponent'}, query: {}}
        } else {
          return {name: 'game_stats', params: {game_id: query.GameId, type: 'lineup'}, query: {}}
        }
      }
    },
    {
      path: '/nba/advanced-wowy',
      redirect: to => {
        const { query } = to
        if (query.Type === undefined) {
          query.Type = 'Team'
        }
        return {name: 'wowy', params: {league: 'nba'}, query: query}
      }
    },
    {
      path: '/gleague/advanced-wowy',
      redirect: to => {
        const { query } = to
        if (query.Type === undefined) {
          query.Type = 'Team'
        }
        return {name: 'wowy', params: {league: 'gleague'}, query: query}
      }
    },
    {
      path: '/nba/wowy',
      redirect: to => {
        const { query } = to
        var newQueryParams = {}
        newQueryParams.TeamId = query.TeamId
        newQueryParams.Season = query.Season
        newQueryParams.SeasonType = query.SeasonType
        if (query.OnFloor !== undefined) {
          newQueryParams['0Exactly0OffFloor'] = query.OnFloor
          if (query.OffFloor !== undefined) {
            newQueryParams['1Exactly0OnFloor'] = query.OffFloor
          }
        } else if (query.OffFloor !== undefined) {
          newQueryParams['0Exactly0OnFloor'] = query.OffFloor
        }
        if (query.Type === undefined) {
          newQueryParams.Type = 'Team'
        } else {
          newQueryParams.Type = query.Type
        }
        return {name: 'wowy', params: {league: 'nba'}, query: newQueryParams}
      }
    },
    {
      path: '/gleague/wowy',
      redirect: to => {
        const { query } = to
        var newQueryParams = {}
        newQueryParams.TeamId = query.TeamId
        newQueryParams.Season = query.Season
        newQueryParams.SeasonType = query.SeasonType
        if (query.OnFloor !== undefined) {
          newQueryParams['0Exactly0OffFloor'] = query.OnFloor
          if (query.OffFloor !== undefined) {
            newQueryParams['1Exactly0OnFloor'] = query.OffFloor
          }
        } else if (query.OffFloor !== undefined) {
          newQueryParams['0Exactly0OnFloor'] = query.OffFloor
        }
        if (query.Type === undefined) {
          newQueryParams.Type = 'Team'
        } else {
          newQueryParams.Type = query.Type
        }
        return {name: 'wowy', params: {league: 'gleague'}, query: newQueryParams}
      }
    },
    {
      path: '/nba/player-on-off',
      redirect: to => {
        return {name: 'on_off', params: {league: 'nba', type: 'player'}}
      }
    },
    {
      path: '/gleague/player-on-off',
      redirect: to => {
        return {name: 'on_off', params: {league: 'gleague', type: 'player'}}
      }
    },
    {
      path: '/nba/team-player-on-off',
      redirect: to => {
        return {name: 'on_off', params: {league: 'nba', type: 'team'}}
      }
    },
    {
      path: '/gleague/team-player-on-off',
      redirect: to => {
        return {name: 'on_off', params: {league: 'gleague', type: 'team'}}
      }
    },
    {
      path: '/nba/team-on-off-for-stat',
      redirect: to => {
        return {name: 'on_off', params: {league: 'nba', type: 'stat'}}
      }
    },
    {
      path: '/gleague/team-on-off-for-stat',
      redirect: to => {
        return {name: 'on_off', params: {league: 'gleague', type: 'stat'}}
      }
    },
    {
      path: '/nba/possession-finder',
      redirect: to => {
        return {name: 'possession_finder', params: {league: 'nba'}}
      }
    },
    {
      path: '/gleague/possession-finder',
      redirect: to => {
        return {name: 'possession_finder', params: {league: 'gleague'}}
      }
    },
    {
      path: '/nba/assist-networks',
      redirect: to => {
        const { query } = to
        if (query.GameId !== undefined) {
          return {name: 'assist_networks', params: {league: 'nba', type: 'game'}}
        } else if (query.LineupId !== undefined) {
          return {name: 'assist_networks', params: {league: 'nba', type: 'lineup'}}
        } else if (query.TeamId !== undefined) {
          return {name: 'assist_networks', params: {league: 'nba', type: 'team'}}
        }
        return {name: 'not_found'}
      }
    },
    {
      path: '/gleague/assist-networks',
      redirect: to => {
        const { query } = to
        if (query.GameId !== undefined) {
          return {name: 'assist_networks', params: {league: 'gleague', type: 'game'}}
        } else if (query.LineupId !== undefined) {
          return {name: 'assist_networks', params: {league: 'gleague', type: 'lineup'}}
        } else if (query.TeamId !== undefined) {
          return {name: 'assist_networks', params: {league: 'gleague', type: 'team'}}
        }
        return {name: 'not_found'}
      }
    },
    {
      path: '/nba/scatter-plots',
      redirect: to => {
        return {name: 'scatter_plots', params: {league: 'nba'}}
      }
    },
    {
      path: '/gleague/scatter-plots',
      redirect: to => {
        return {name: 'scatter_plots', params: {league: 'gleague'}}
      }
    },
    {
      path: '/nba/player-season-stats',
      redirect: to => {
        const { query } = to
        var newQueryParams = {}
        newQueryParams.EntityType = 'Player'
        newQueryParams.EntityId = query.PlayerId
        return {name: 'season_stats', params: {league: 'nba'}, query: newQueryParams}
      }
    },
    {
      path: '/gleague/player-season-stats',
      redirect: to => {
        const { query } = to
        var newQueryParams = {}
        newQueryParams.EntityType = 'Player'
        newQueryParams.EntityId = query.PlayerId
        return {name: 'season_stats', params: {league: 'gleague'}, query: newQueryParams}
      }
    },
    {
      path: '/nba/team-season-stats',
      redirect: to => {
        const { query } = to
        var newQueryParams = {}
        if (query.Type === 'Opponent') {
          newQueryParams.EntityType = 'Opponent'
        } else {
          newQueryParams.EntityType = 'Team'
        }
        newQueryParams.EntityId = query.TeamId
        return {name: 'season_stats', params: {league: 'nba'}, query: newQueryParams}
      }
    },
    {
      path: '/gleague/team-season-stats',
      redirect: to => {
        const { query } = to
        var newQueryParams = {}
        if (query.Type === 'Opponent') {
          newQueryParams.EntityType = 'Opponent'
        } else {
          newQueryParams.EntityType = 'Team'
        }
        newQueryParams.EntityId = query.TeamId
        return {name: 'season_stats', params: {league: 'gleague'}, query: newQueryParams}
      }
    },
    {
      path: '*',
      redirect: { name: 'not_found' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js